<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" 
             fxLayoutAlign="center center"
             fxLayout.gt-sm="row" 
             fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- TÍTULO -->
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16" style="color: #fff;">
                        business
                    </mat-icon>
                    <span class="logo-text h1" style="color: #fff;">
                        Boleta COE
                    </span>
                </div>
                <!-- / TÍTULO -->

                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Consultar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Consultar Boleta"
                            (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                    </button>

                    <!-- Botão Importar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Importar Arquivo"
                            (click)="openUpload()"
                            *ngIf="this.user.role_id == 4 || this.user.role_id == 7 || this.user.role_id == 2 || this.user.role_id == 9">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>

                    <!-- Botão Exportar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Exportar Boleta"
                            (click)="getAllExport()">
                        <mat-icon>cloud_download</mat-icon>
                    </button>

                    <!-- Botão Adicionar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Adicionar Boleta"
                            (click)="openCadastro()">
                        <mat-icon>add_circle</mat-icon>
                    </button>

                    <!-- Botão Atualizar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Atualizar Status"
                            (click)="openAtualizar()">
                        <mat-icon>update</mat-icon>
                    </button>
                </div>
                <!-- / BOTÕES DE AÇÃO -->
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material striped' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [selected]="selected"
                [selectionType]="SelectionType.checkbox"                
                [selectAllRowsOnPage]="false"
                (select)="onSelect($event)"
                (sort)="onSort($event)"
                [rows]='rows'>

                <ngx-datatable-column
                    [width]="30"
                    [sortable]="false"
                    [canAutoResize]="false"
                    [draggable]="false"
                    [resizeable]="false"
                    [headerCheckboxable]="true"
                    [checkboxable]="true">
                </ngx-datatable-column>

                <ngx-datatable-column name="Data" prop="data_operacao" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-data_operacao="value" ngx-datatable-cell-template>
                        {{data_operacao | date:'dd/MM/yyyy H:mm'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column 
                    name="Responsável" 
                    matTooltip='Responsavel por realizar a operação' 
                    prop="operador_id" 
                    [sortable]="true">

                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{row.operador.name}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Escritório" prop="escritorio_id" [sortable]="true" *ngIf="this.user.role_id != 5">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ getEscritorioCliente(row.cliente) }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Conta Cliente" prop="numero_xp" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.cliente.numero_xp }} - {{ row.cliente.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Característica" prop="caracteristica_id" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.caracteristica.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Compra/Venda" prop="compra_venda">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.compra_venda }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Valor (R$)" prop="valor" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-valor="value" ngx-datatable-cell-template>
                        {{valor | number : '1.2-2'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Status" prop="status_id" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span  
                            [ngClass]="{ 
                                'status_boleta_efetivada': row.status_id == 10, 
                                'status_efeitivada_parcial': row.status_id == 15, 
                                'status_boleta_error': row.status_id != 10 && row.status_id != 1 && row.status_id != 2 && row.status_id != 3  }">
                            {{row.status.nome}}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        
                        <button mat-icon-button matTooltip="Altera Boleta" (click)="openAlterar(row.id)">
                            <mat-icon aria-label="Editar">edit</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir Boleta." (click)="delete(row.id)">
                            <mat-icon aria-label="Excluir Boleta">delete</mat-icon>
                        </button>    
                      
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>